module.exports = __webpack_public_path__ + "img/chris3-b.bc303031.jpg";